import { equals2v6cggk171b6e as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function valueOf(_this__u8e3s4, name) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = _this__u8e3s4.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (equals(element.u49_1, name, true)) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_safe_receiver = tmp$ret$0;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v49_1;
}
//region block: exports
export {
  valueOf as valueOf2fyebtslgrf1c,
};
//endregion

//# sourceMappingURL=HttpHeaders.mjs.map
